import { render, staticRenderFns } from "./ComprasDiretasDisponiveisTabela.vue?vue&type=template&id=560d325e&scoped=true"
import script from "./ComprasDiretasDisponiveisTabela.vue?vue&type=script&lang=js"
export * from "./ComprasDiretasDisponiveisTabela.vue?vue&type=script&lang=js"
import style0 from "./ComprasDiretasDisponiveisTabela.vue?vue&type=style&index=0&id=560d325e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560d325e",
  null
  
)

export default component.exports